import { Div, RefString, Snack } from "@tblabs/truffle";
import { AdminStepPrinter, AdminStepPrinterV2 } from "../../../Components/AdminStepPrinter";
import { Center } from "../../../Components/Utils/Center";
import { CenteredLoader } from "../../../Components/Utils/CenteredLoader";
import { OrdersManager } from "../../../Services/OrdersManager";
import { Router } from "../../../Services/Router";
import { StepsPrinter, StepsPrinterV2 } from "../../../Services/StepsPrinter";
import { OrderEventsCalendar } from "../../../Components/OrderEventsCalendar";
import { MessageBus } from "../../../Services/MessageBus/MessageBus";
import { RemoteStorageChatConnector } from "../../../Chat/Storage/RemoteStorageChatConnector";
import { Chat } from "../../../Chat/Services/Chat";
import { ChatUser } from "../../../Chat/Models/ChatUser";
import { AuthService } from "../../../Services/Auth/AuthService";
import { ChatView } from "../../../Chat/Components/ChatView";
import { PeoplePrinter } from "./Components/PeoplePrinter";
import { TabsV2 } from "../../../Components/Utils/Tabs";
import { AgentsProvider } from "../../../Services/AgentsProvider";
import { OrderHeader } from "./Components/OrderHeader";
import { Icons } from "../../../Components/Utils/Icons";
import { MoneyList } from "../OrdersView/Views/Table/Components/MoneyList";
import { OrderNotes } from "../OrdersView/Views/Table/Components/OrderNotes";
import { BasketInfo } from "./Components/BasketInfo";


export class AdminOrderViewPage extends Div
{
    private CHAT_ENABLED = false;

    private loader = new CenteredLoader("Pobieranie zamówienia... Proszę czekać");

    constructor(
        private _manager: OrdersManager,
        private _messageBus: MessageBus,
        private _router: Router,
        private _auth: AuthService,
        private _agents: AgentsProvider,
        private orderId: string)
    {
        super();

        this.Append(
            this.loader
        );
    }

    protected async OnAppend(): Promise<void>
    {
        const order = await this._manager.GetOne(this.orderId);

        this.loader.RemoveSelf();

        if (!order)
        {
            this.Append(
                new Center(`😥 Nie znaleziono zamówienia. Jego adres jest niepoprawny lub zostało zamknięte albo usunięte.`));
            return;
        }

        order.OnChange(async () => 
        {
            await this._manager.Update(order);
            new Snack("✅ Zmiany zapisane");
        });

        const view = new RefString("Przebieg").Storable("admin-order-view");

        const tabs = new TabsV2(view)
            .Add(Icons.Basket, "Koszyk", () => new BasketInfo(order))
            .Add(Icons.Route, "Przebieg", () => new StepsPrinter(order.Steps.Items, "admin", (step) => new AdminStepPrinter(this._router, this._agents, step), true))
            .Add(Icons.Route, "PrzebiegV2", () => new StepsPrinterV2(order.Steps.Items, "admin", 
                (step) => new AdminStepPrinterV2(this._router, this._agents, step)))
            .Add(Icons.Calendar, "Kalendarz", () => new OrderEventsCalendar(order).MarginTop(32))
            .Add(Icons.User, "Ludzie", () => new PeoplePrinter(order.People))
            .Add(Icons.Money, "Rozliczenie", () => new MoneyList(order))
            .Add(Icons.Notes, "Notatki", () => new OrderNotes(order))

        if (this.CHAT_ENABLED)
        {
            const _connector = new RemoteStorageChatConnector(this._messageBus, order.Id);
            const chat = new Chat(_connector, new ChatUser({ Name: this._auth.UserInfo?.User?.ChatName || "Admin" }));

            await _connector.Load();

            tabs.Add(Icons.Chat, `Czat${chat.IsUnread ? "🔴" : ""}`, () => new ChatView(chat))
        }

        this.Append(
            new OrderHeader(this._router, this._manager, order).MarginTop(16).MarginBottom(16),
            tabs,
            // new Div().Append(
            //     new Link("🛒 Jak coś dodać do zamówienia?").Margin(16),
            //     new Link("💰 Co kiedy wpłata jest inna niż wymagana?").Margin(16),
            //     new Link("💰 Co jeśli kaucja jest z innego zamówienia?").Margin(16),
            //     new Link("⏳ Jak przedłużyć zamówienie?").Margin(16),
            //     new Link("⏰ Jak skrócić zamówienie?").Margin(16),
            //     new Link("🚪 Procedura zamknięcia").Margin(16),
            //     new Link("✖️ Procedura anulowania").Margin(16),
            // ).MarginTop(64).Padding(16).BorderTop(4, "#ccc", "dashed"),
        );
    }
}
